import React from 'react';
import styled from 'styled-components';
import { _ } from 'rc-locales';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { useMaterialGroup } from '../hooks';
import GroupItem from '../components/GroupItem';
import { GroupLoading } from '../components/Loading';

const Container = styled.div`
  background-color: white;
  margin-top: 43px;
  max-height: auto;
  overflow: auto;
  padding: 1px;
`;

const Title = styled.h2`
  all: initial;
  display: block;
  font-weight: bold !important;
  font-size: 21px !important;
  margin-bottom: 0px;
  padding: 30px 0 25px;
  color: #11A9CE;
`;

const ShowMoreLink = styled.button`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;


  &:focus {
    outline: none;
  }

  all: initial;
  border: none;
  text-align: center;
  cursor: pointer;
  display: block;
  margin: 10px auto;
  font-family: inherit !important;
  background-color: transparent;
  font-weight: bold !important;
  text-decoration: none;
  font-size: 16px !important;
  color: #0086C2;
  border-bottom: 1px solid transparent;
  padding-bottom: 3px;

  &:hover{
    color: #11A9CE;
    border-bottom: 1px solid #11A9CE;
    padding-bottom: 3px;
  }
`;

const ShowMoreText = styled.span`
  &:focus {
    outline: none;
  }
`;

const Group = ({ localityId, onClick }) => {
  const { materials, error, loading } = useMaterialGroup(localityId);
  const history = useHistory();

  const getGroup = (id) => {
    onClick(id);
    history.push('/wgw/search');
  };

  const showMore = () => {
    history.push('/wgw/list');
  };

  return (
    <Container>
      <Title>
        {_('wgw.popularSearches')}
      </Title>
      <div className="clearfix">
        {
          loading && <GroupLoading />
        }
        {
          (!error && materials.length)
            ? (
              materials
                .sort((a, b) => parseInt(a.order, 10) > parseInt(b.order, 10))
                .map((item) => (
                  <GroupItem
                    key={item.id}
                    item={item}
                    onClick={getGroup}
                  />
                ))
            ) : null
        }
      </div>
      <ShowMoreLink tabIndex="0" onClick={showMore} aria-label="show more the material items button">
        <ShowMoreText tabIndex="-1">
          {_`wgw.showMore`}
        </ShowMoreText>
      </ShowMoreLink>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  localityId: state.app.localityId
});


export default connect(mapStateToProps)(Group);
